/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Rental_Rate_StandardInputs */

const en_rental_rate_standard = /** @type {(inputs: Rental_Rate_StandardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Standard Daily Rate`)
};

const es_rental_rate_standard = /** @type {(inputs: Rental_Rate_StandardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tarifa Diaria Estándar`)
};

const fr_rental_rate_standard = /** @type {(inputs: Rental_Rate_StandardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tarif journalier standard`)
};

const de_rental_rate_standard = /** @type {(inputs: Rental_Rate_StandardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Standard-Tagesrate`)
};

const id_rental_rate_standard = /** @type {(inputs: Rental_Rate_StandardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tarif Harian Standar`)
};

/** @type {(inputs: Rental_Rate_StandardInputs) => LocalizedString} */
const ja_rental_rate_standard = en_rental_rate_standard;

/** @type {(inputs: Rental_Rate_StandardInputs) => LocalizedString} */
const zh_rental_rate_standard = en_rental_rate_standard;

/** @type {(inputs: Rental_Rate_StandardInputs) => LocalizedString} */
const ar_rental_rate_standard = en_rental_rate_standard;

/** @type {(inputs: Rental_Rate_StandardInputs) => LocalizedString} */
const it_rental_rate_standard = en_rental_rate_standard;

/** @type {(inputs: Rental_Rate_StandardInputs) => LocalizedString} */
const ru_rental_rate_standard = en_rental_rate_standard;

/** @type {(inputs: Rental_Rate_StandardInputs) => LocalizedString} */
const pt_rental_rate_standard = en_rental_rate_standard;

/** @type {(inputs: Rental_Rate_StandardInputs) => LocalizedString} */
const ko_rental_rate_standard = en_rental_rate_standard;

/**
* | output |
* | --- |
* | "Standard Daily Rate" |
*
* @param {Rental_Rate_StandardInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const rental_rate_standard = /** @type {((inputs?: Rental_Rate_StandardInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rental_Rate_StandardInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_rental_rate_standard(inputs)
	if (locale === "es") return es_rental_rate_standard(inputs)
	if (locale === "fr") return fr_rental_rate_standard(inputs)
	if (locale === "de") return de_rental_rate_standard(inputs)
	if (locale === "ja") return ja_rental_rate_standard(inputs)
	if (locale === "zh") return zh_rental_rate_standard(inputs)
	if (locale === "ar") return ar_rental_rate_standard(inputs)
	if (locale === "id") return id_rental_rate_standard(inputs)
	if (locale === "it") return it_rental_rate_standard(inputs)
	if (locale === "ru") return ru_rental_rate_standard(inputs)
	if (locale === "pt") return pt_rental_rate_standard(inputs)
	return ko_rental_rate_standard(inputs)
});